export default "__VITE_ASSET__b0b49315__"